import axiosClient from "./axiosClient";
import { IRoleGroupDTO } from "@interfaces/IRoleGroupDTO";

const RoleGroupService = {
  getRoleGroupId: async (): Promise<IRoleGroupDTO | null> => {
    try {
      const response = await axiosClient.get("/role_group_api/role_group/id");
      return response.data;
    } catch (error) {
      console.error("Failed to fetch role group ID:", error);
      return null;
    }
  },
  getAllRoleGroups: async (): Promise<IRoleGroupDTO[]> => {
    try {
      const response = await axiosClient.get("/role_group_api/role_groups");
      return response.data;
    } catch (error) {
      console.error("Failed to fetch role groups:", error);
      return [];
    }
  },
  // Other methods...
};

export default RoleGroupService;
